/* eslint-disable */
// Strings needs to be explictly stated here as they can cause type issues elsewhere.

export const REPO_URL: string = "https://gitlab.o-code.ru/revolt/revite/commit";
export const GIT_REVISION = __GIT_REVISION__;
export const GIT_BRANCH = __GIT_BRANCH__;

console.log("GIT_REVISION", GIT_REVISION, "GIT_BRANCH", GIT_BRANCH);

export function isDebug() {
    return import.meta.env.FORCE_DEBUG === "1" || import.meta.env.DEV;
}
